import {Avatar, Box, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {WaveIcon} from "@hugeicons/core-free-icons";
import {grey} from "@mui/material/colors";
import React from "react";
import AreaChart from "./AreaChart";

export const MiniCard = ({
                             subtitle,
                             title,
                             icon: iconData = WaveIcon,
                             data = [],
                             color = "#3f51b5",
                             hideChart = false,
                             action = null,
                             chartOverlay = null,
                             decimals = 2,
                         }) => {
    return (
        <Stack direction="column" gap={0} sx={{borderRadius: 3, p: 2, pb: 1, overflow: "visible"}}
               className={"border-shadow"}>
            <Stack direction={"row"} gap={1.5} alignItems="center" sx={{pb: 1}}>
                <Avatar sx={{color: color, width: 32, height: 32, bgcolor: `${color}15`, fontSize: "1.1rem"}}
                        className={"border-shadow"}>
                    <HugeiconsIcon icon={iconData} size={17}/>
                </Avatar>
                <Box>
                    <Typography variant={"body2"} color={grey[500]} sx={{lineHeight: 1.3}}>{subtitle}</Typography>
                    <Typography variant={"h5"} fontWeight={500} sx={{lineHeight: 1.3}}>{title}</Typography>
                </Box>
                {action && <Box sx={{ml: "auto", alignSelf: "flex-start", mt: -0.5, mr: -0.5}}>{action}</Box>}
            </Stack>

            {/* mx: -2 cancels the card padding so the chart spans the full card width */}
            <Box id={"parent-box"} sx={{
                height: "90px", mx: -2, overflow: "visible", position: "relative",
                // chartOverlay (e.g. navigation) shows on hover, and always on touch screens
                "& .chart-overlay": {opacity: 0, transition: "opacity 0.15s"},
                "&:hover .chart-overlay, & .chart-overlay:focus-within": {opacity: 1},
                "@media (hover: none)": {"& .chart-overlay": {opacity: 1}},
            }}>
                {hideChart
                    ? chartOverlay && (
                        <Typography sx={{fontSize: 12, color: grey[400], textAlign: "center", lineHeight: "90px"}}>
                            No data
                        </Typography>
                    )
                    : <AreaChart data={data} colors={[color]} decimals={decimals} showYAxis/>}
                {chartOverlay && <Box className={"chart-overlay"}>{chartOverlay}</Box>}
            </Box>
        </Stack>
    )
}
